/**
 * Check whether a JSON object can be converted to a string.
 *
 * This may not be possible, for example, with recursive JSON objects.
 * @param  {any}     datum A JSON object
 * @return {boolean}       `true` if the object can be stringified; `false` otherwise
 */
export function isStringifiable(datum: any): boolean {
  try {
    JSON.stringify(datum);
    return true;
  } catch (_error) {
    return false;
  }
}
